import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useStoreAdminContext } from 'context/StoreAdminContext';
import { ROUTES } from 'config/routes';

const AdminGuestRoute: React.FC = () => {
  const { isAdminAuthenticated } = useStoreAdminContext();
  if (isAdminAuthenticated) {
    return <Navigate to={ROUTES.ADMIN} replace />;
  }
  return <Outlet />;
};

export default AdminGuestRoute;
